import { Col, Row } from "react-bootstrap";
import { renderSongScore } from "../helperRenders";

export default function SongScoreTrendRow({ item, setCatalogueSong }) {
    return (
        <Row onClick={() => setCatalogueSong(item.song)} className={`py-1 border-bottom align-items-center hoverable fs-8-xs row-gap-1`}>
            <Col>
                <Row className="ps-2 ps-xl-0">
                    <Col xs={"auto"} xl className={`align-content-center ps-1 pe-1 ps-xl-og pe-xl-og fs-7 fw-bold fw-xl-normal`}>
                        {item.song.artist}
                    </Col>
                    <Col xs="auto" className=" align-content-center px-0 d-xl-none">
                        -
                    </Col>
                    <Col xs={"auto"} xl className=" align-content-center px-1 ps-xl-og pe-xl-og fs-7 fw-bold fw-xl-normal">
                        {item.song.title}
                    </Col>
                </Row>
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={1} className="d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Month:</span>
                {renderSongScore(item.music_test_data.song_score_month)}
            </Col>
            <Col xs={"auto"} xl={1} className="d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Week</span>
                {renderSongScore(item.music_test_data.song_score)}
            </Col>
            <Col xs={12} className="d-md-none"></Col>
            <Col xs={"auto"} xl={1} className="d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Week -1:</span>
                {renderSongScore(item.music_test_data.song_score_week_1)}
            </Col>
            <Col xs={"auto"} xl={1} className="d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Week -2:</span>
                {renderSongScore(item.music_test_data.song_score_week_2)}
            </Col>
            <Col xs={"auto"} xl={1} className="d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Week -3:</span>
                {renderSongScore(item.music_test_data.song_score_week_3)}
            </Col>
        </Row>
    );
}
